import { render, staticRenderFns } from "./UploadCV.vue?vue&type=template&id=61deeafc"
import script from "./UploadCV.vue?vue&type=script&lang=ts"
export * from "./UploadCV.vue?vue&type=script&lang=ts"
import style0 from "./UploadCV.vue?vue&type=style&index=0&id=61deeafc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports